import { TableCustomCell } from 'src/app/modules/component/table/components/TableCustomCell';
import { TableCustomHeader } from 'src/app/modules/component/table/components/TableCustomHeader';
import { formatDateTime } from 'src/app/modules/utils/FormatUtils';

export const DANH_SACH_DICH_VU_KHAC_COLUMNS = [
	{
		Header: (props: any) => (
			<TableCustomHeader
				tableProps={props}
				title={'STT'}
				className=" text-center text-white"
			/>
		),
		id: 'STT',
		Cell: ({ ...props }) => (
			<TableCustomCell className="text-center" data={(props.row.index + 1).toString()} />
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader<any>
				tableProps={props}
				title="Tên dịch vụ"
				className=" min-w-200px text-center"
			/>
		),
		id: 'Tên dịch vụ',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="min-w-150px "
				data={props.data[props.row.index]?.termName || ''}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader<any> tableProps={props} title="SL" className="text-center" />
		),
		id: 'Số lượng',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="min-w-50px text-center"
				data={props.data[props.row.index]?.soLuong || 1}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader<any>
				tableProps={props}
				title="Loại ngày giường"
				className="min-w-200px text-center"
			/>
		),
		id: 'bedTypeName',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="min-w-100px text-start "
				data={props.data[props.row.index]?.obs?.bedTypeName || ''}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader<any>
				tableProps={props}
				title="Mã giường"
				className="min-w-100px text-center"
			/>
		),
		id: 'Mã giường',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="min-w-100px text-start "
				data={props.data[props.row.index]?.obs?.bedCode || ''}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader<any>
				tableProps={props}
				title="Ngày vào"
				className="min-w-100px text-center"
			/>
		),
		id: 'bedDayStartDate',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="min-w-100px text-center"
				data={formatDateTime(props.row.original?.obs?.bedDayStartDate)}
			/>
		),
	},
	{
		Header: (props: any) => (
			<TableCustomHeader<any>
				tableProps={props}
				title="Ngày ra"
				className="min-w-100px text-center"
			/>
		),
		id: 'bedDayEndDate',
		Cell: ({ ...props }) => (
			<TableCustomCell
				className="min-w-100px text-center"
				data={formatDateTime(props.data[props.row.index]?.obs?.bedDayEndDate)}
			/>
		),
	},
];
